import React from 'react'
import { useTranslation } from 'react-i18next'
import { DayButtonProps } from '../types'
import { IconInbox } from './Icon'
import { useLpAvailabilityPageStore } from '../../../store/lpAvailabilityPageStore'
import { toDate } from '../toDate'
import { AvailabilityStatusIcon } from '../../availability-status/AvailabilityStatusIcons'

export const DayButton = (props: DayButtonProps) => {
  const { day, modifiers, getPrice, isShowIcon = true, ...buttonProps } = props
  const { t } = useTranslation()
  const { isJpe } = useLpAvailabilityPageStore()
  const dayDate = toDate(day.date)
  const price = getPrice(dayDate)

  // 幅は 52px（w-13）。md 未満は DatePicker の root（@container）の幅の 1/7 まで縮む。
  // md 以上はコンテナが無く画面の幅の 1/7（52px より広い）になるので、52px のまま
  return (
    <button
      {...buttonProps}
      className={`
        flex flex-col h-16 items-center mt-1 w-13 max-w-[calc(100cqi/7)]
        ${isShowIcon ? 'justify-center' : 'justify-center'}
        ${modifiers.listed ? 'border border-gray-300' : ''}
        ${modifiers.available ? 'border-green' : ''}
        ${modifiers.startRange || modifiers.endRange ? 'bg-green' : ''}
        ${
          isJpe && modifiers.listed && !modifiers.available && !modifiers.startRange && !modifiers.endRange && !modifiers.inRange
            ? 'bg-gray-100'
            : ''
        }
        ${modifiers.startRange ? 'rounded-l' : modifiers.endRange ? 'rounded-r' : modifiers.inRange ? '' : 'rounded'}
        ${!modifiers.startRange && !modifiers.endRange && modifiers.inRange ? 'bg-green-100' : ''}
      `}
      disabled={!modifiers.available}
    >
      <div
        className={`relative
          ${modifiers.available && !modifiers.inRange ? 'underline font-bold' : ''}
          ${
            modifiers.startRange || modifiers.endRange
              ? 'text-white'
              : modifiers.available
                ? 'text-primary'
                : isJpe && modifiers.listed
                  ? 'text-gray-600'
                  : 'text-gray-200'
          }
        `}
      >
        {dayDate.getDate()}
        {modifiers.holiday && (
          <span className="absolute text-red-500 font-size-12 font-normal" style={{ marginTop: '-4px' }}>
            *
          </span>
        )}
      </div>
      {isShowIcon && (
        <>
          {modifiers.listed &&
            modifiers.available &&
            !modifiers.forSale &&
            (isJpe ? (
              <AvailabilityStatusIcon
                kind="available"
                size={12}
                className={modifiers.startRange || modifiers.endRange ? '[&_path]:stroke-white' : undefined}
              />
            ) : (
              <div
                className={`
                w-3 h-3 rounded-full border-2 border-solid
                ${modifiers.startRange || modifiers.endRange ? 'border-white' : 'border-green'}
              `}
              />
            ))}
          {modifiers.listed &&
            modifiers.available &&
            modifiers.forSale &&
            (isJpe ? (
              <AvailabilityStatusIcon
                kind="contact"
                size={18}
                className={modifiers.startRange || modifiers.endRange ? '[&_path]:stroke-white' : undefined}
              />
            ) : (
              <IconInbox />
            ))}
          {modifiers.listed &&
            !modifiers.available &&
            (isJpe ? (
              <AvailabilityStatusIcon
                kind="sold_out"
                size={18}
                className={modifiers.startRange || modifiers.endRange ? '[&_path]:stroke-white' : undefined}
              />
            ) : (
              <span className="text-gray-400 font-size-12">{t('reservation_confirm.modal_booking.sold_out')}</span>
            ))}
        </>
      )}

      {modifiers.listed && (
        <div
          className={`
            tracking-tight leading-tight
            font-size-11
            ${modifiers.startRange || modifiers.endRange ? 'text-white' : modifiers.available ? 'text-green' : 'text-gray-200'}
          `}
        >
          {isJpe && !modifiers.available ? (
            <span className={modifiers.startRange || modifiers.endRange ? 'text-white' : 'tracking-tight text-gray-600'}>
              {t('reservation_confirm.modal_booking.sold_out')}
            </span>
          ) : (
            <>
              {!modifiers.forSale && price}
              {modifiers.forSale ? t('reservation_confirm.modal_booking.contact') : ''}
            </>
          )}
        </div>
      )}
    </button>
  )
}
